const TelephoneConstant = {
    AI_ASSISTANT_STATUS: {
        ON: 'ON',
        OFF: 'OFF'
    },

    TELEPHONE_RECEIVING_CALL_EXECUTION_TIME_PERIOD_OPTIONS: {
        ON: 'ON',
        OFF: 'OFF'
    },

    CALL_DIRECTION: {
        INBOUND: 'inbound',
        OUTBOUND: 'outbound'
    },
    
    CALL_TYPE: {
        PHONE_CALL: 'phone_call',
        VOICE_CALL: 'voice_call',
        APP_INTEGRATION: 'app_integration',
    },

    CALL_CATEGORY: {
        TRAINING: 'TRAINING',
        VOICE: 'VOICE',
        PHONE: 'PHONE',
    },

    METADATA_TELEPHONE_TYPE: {
        TRAINING: 'TRAINING',
        COACHING: 'COACHING',
        APP_INTEGRATION: 'APP_INTEGRATION',
    },

    ACTION: {
        GET_INCOMING_INFO_VOICE_CALL: 'GET_INCOMING_INFO_VOICE_CALL',
        GET_LIST_PHONE_NUMBERS: 'GET_LIST_PHONE_NUMBERS',
        SEARCH_PHONE_NUMBERS: 'SEARCH_PHONE_NUMBERS',
        GET_INCOMING_INFO_BY_PHONE_NUMBER: 'GET_INCOMING_INFO_BY_PHONE_NUMBER',
        GET_LIST_B2C_USER_INFO: 'GET_LIST_B2C_USER_INFO',
        GET_LIST_B2C_USER_INFO_IN_PROJECT: 'GET_LIST_B2C_USER_INFO_IN_PROJECT',
        SEARCH_PHONE_CONTACTS: 'SEARCH_PHONE_CONTACTS',
        TWILIO_INIT_DEVICE: 'TWILIO_INIT_DEVICE',
        TWILIO_UPDATE_PHONE_AVAILABILITY: 'TWILIO_UPDATE_PHONE_AVAILABILITY',
        TWILIO_UPDATE_HEARTBEAT_PHONE_AVAILABILITY: 'TWILIO_UPDATE_HEARTBEAT_PHONE_AVAILABILITY',
        TEST_PHONE_INIT_DEVICE: 'TEST_PHONE_INIT_DEVICE',
        TEST_PHONE_UPDATE_WEBHOOK: 'TEST_PHONE_UPDATE_WEBHOOK',
        TEST_PHONE_REGISTER_AGENT: 'TEST_PHONE_REGISTER_AGENT',
        TEST_PHONE_UNREGISTER_AGENT: 'TEST_PHONE_UNREGISTER_AGENT',
        GET_AVAILABLE_AGENTS_FOR_VOICE_CALL: 'GET_AVAILABLE_AGENTS_FOR_VOICE_CALL',
        TWILIO_HOLD_CALL: 'TWILIO_HOLD_CALL',
        TWILIO_UNHOLD_CALL: 'TWILIO_UNHOLD_CALL',
        TWILIO_GET_CALL_STATE: 'TWILIO_GET_CALL_STATE',
        // OpenAI WebRTC Actions
        OPENAI_WEBRTC_CREATE_SESSION: 'CREATE_SESSION',
        OPENAI_WEBRTC_CALL_CONNECTED: 'CALL_CONNECTED',
        OPENAI_WEBRTC_SAVE_TRANSCRIPT: 'SAVE_TRANSCRIPT',
        OPENAI_WEBRTC_SAVE_RECORDING: 'SAVE_RECORDING',
        OPENAI_WEBRTC_END_CALL: 'END_CALL',
        OPENAI_WEBRTC_UPDATE_HEARTBEAT: 'UPDATE_HEARTBEAT',
        OPENAI_WEBRTC_INCREMENT_HOLD_COUNT: 'INCREMENT_HOLD_COUNT',
        // Execute an AI tools call (SIF) from the WebRTC training client (CR-2026-005 / TEL-009)
        OPENAI_WEBRTC_EXECUTE_FUNCTION_CALL: 'EXECUTE_FUNCTION_CALL',
        // App Integration Actions
        APP_INTEGRATION_START_CALL: 'APP_INTEGRATION_START_CALL',
        APP_INTEGRATION_END_CALL: 'APP_INTEGRATION_END_CALL',
        APP_INTEGRATION_UPDATE_HEARTBEAT: 'APP_INTEGRATION_UPDATE_HEARTBEAT',
        APP_INTEGRATION_UPDATE_TICKET_DATA: 'APP_INTEGRATION_UPDATE_TICKET_DATA',
        APP_INTEGRATION_SAVE_TRANSCRIPT: 'APP_INTEGRATION_SAVE_TRANSCRIPT',
        APP_INTEGRATION_TRANSCRIPT: 'APP_INTEGRATION_TRANSCRIPT',
    },

    PHONE_SEARCH_TAB: {
        HISTORY: 'TAB_HISTORY',
        CONTACTS: 'TAB_CONTACTS',
        TRAINING: 'TAB_TRAINING',
        APP_INTEGRATION: 'TAB_APP_INTEGRATION',
    },

    RECIPIENT_TYPE: {
        PROJECT_IN_ORG: 'project_in_org',
        B2B_CUSTOMER_PROJECT: 'b2b_customer_project', // out of scope
        B2B_SUPPORT_PROJECT: 'b2b_support_project', // out of scope
        USER_IN_ORG: 'user_in_org',
        B2C_CUSTOMER: 'b2c_customer'
    },

    PHONE_SEARCH_PAGE_SIZE: 20,

    LIST_TELEPHONE_FIELD_ON_SUBSCRIPTION_UPDATE: [
        'telephone_call_handler',
        'telephone_end_time',
        'telephone_duration',
        'telephone_call_recording_url',
        'telephone_transcript_url',
        'telephone_ai_call_summary',
        'telephone_ai_operator_prompt',
        'telephone_hold_count',
    ],
    
    TELEPHONE: {
        SYSTEM_FIELD: {
            CALL_STATUS: 'telephone_call_status',
            CALL_TYPE: 'telephone_call_type',
            CALL_MODE: 'telephone_call_mode',
            FROM: 'telephone_from',
            TO: 'telephone_to',
            CALL_HANDLER: 'telephone_call_handler',
            CALLER_LANGUAGE: 'telephone_caller_language',
            RECEIVER_LANGUAGE: 'telephone_receiver_language',
            START_TIME: 'telephone_start_time',
            END_TIME: 'telephone_end_time',
            DURATION: 'telephone_duration',
            CALL_RECORDING_URL: 'telephone_call_recording_url',
            TRANSCRIPT_URL: 'telephone_transcript_url',
            AI_CALL_SUMMARY: 'telephone_ai_call_summary',
            HUMAN_MEMO: 'telephone_human_memo',
            AI_SCORE: 'telephone_ai_score',
            AI_EVALUATION: 'telephone_ai_evaluation',
            EVALUATOR: 'telephone_evaluator',
            HUMAN_SCORE: 'telephone_human_score',
            HUMAN_EVALUATION: 'telephone_human_evaluation',
            AI_OPERATOR_PROMPT: 'telephone_ai_operator_prompt',
            RELATED_TICKETS: 'telephone_related_tickets',
            CHILD_LINK: 'telephone_child_link',
            // New fields
            TICKET_STATUS: 'field_status',
            REVIEW_STATUS: 'telephone_review_status',
            FOLLOW_UP_STATUS: 'telephone_follow_up_status',
            NEXT_CALL: 'telephone_next_call',
            HOLD_COUNT: 'telephone_hold_count',
        },
        NOT_EDIT_FIELD: {
            TELEPHONE_CALL_STATUS: 'telephone_call_status',
            TELEPHONE_CALL_TYPE: 'telephone_call_type',
            TELEPHONE_CALL_MODE: 'telephone_call_mode',
            TELEPHONE_FROM: 'telephone_from',
            TELEPHONE_TO: 'telephone_to',
            TELEPHONE_CALL_HANDLER: 'telephone_call_handler',
            TELEPHONE_START_TIME: 'telephone_start_time',
            TELEPHONE_END_TIME: 'telephone_end_time',
            TELEPHONE_DURATION: 'telephone_duration',
            TELEPHONE_CALL_RECORDING_URL: 'telephone_call_recording_url',
            TELEPHONE_TRANSCRIPT_URL: 'telephone_transcript_url',
            TELEPHONE_AI_CALL_SUMMARY: 'telephone_ai_call_summary',
            TELEPHONE_AI_SCORE: 'telephone_ai_score',
            TELEPHONE_AI_EVALUATION: 'telephone_ai_evaluation',
            TELEPHONE_AI_OPERATOR_PROMPT: 'telephone_ai_operator_prompt',
            TELEPHONE_RELATED_TICKETS: 'telephone_related_tickets',
            TELEPHONE_NEXT_CALL: 'telephone_next_call',
            TELEPHONE_CHILD_LINK: 'telephone_child_link',
            TELEPHONE_HOLD_COUNT: 'telephone_hold_count',
            // New system-generated fields
            TICKET_STATUS: 'field_status',
            NEXT_CALL: 'telephone_next_call',
        },
        /**
         * HIDDEN_FIELDS_IN_QA_DETAIL
         * List of telephone fields that should be hidden when viewing
         * TELEPHONE_FORMAT ticket in QA detail screen (問い合わせ詳細)
         */
        HIDDEN_FIELDS_IN_QA_DETAIL: [
            'telephone_call_type',        // 通話種類
            'telephone_call_mode',        // 通話モード
            'telephone_call_handler',     // 応対者
            'telephone_human_memo',       // 通話メモ
            'telephone_ai_score',         // AI-点数
            'telephone_ai_evaluation',    // AI-フィードバック内容
            'telephone_evaluator',        // 評価担当
            'telephone_human_score',      // 人間-点数
            'telephone_human_evaluation', // 人間-フィードバック内容
            'telephone_ai_operator_prompt', // AIオペレータプロンプトナレッジ
            // New fields to hide in QA detail
            'field_status',               // ステータス
            'telephone_review_status',    // 評価ステータス
            'telephone_follow_up_status', // フォローアップ状況
            'telephone_next_call',        // 次回の通話
            'telephone_hold_count',
        ],

        HIDDEN_FIELDS_FOR_TRAINING_CALL: [
            'telephone_call_mode',
            'telephone_from',
            'telephone_to',
            'telephone_caller_language',
            'telephone_receiver_language',
            'telephone_related_tickets',
            'telephone_next_call',
            'telephone_child_link',
            'personInCharge',
            'telephone_follow_up_status',
        ],

        HIDDEN_FIELDS_FOR_APP_INTEGRATION_CALL: [
            'telephone_call_mode',
            'telephone_from',
            'telephone_to',
            'telephone_caller_language',
            'telephone_receiver_language',
            'telephone_related_tickets',
            'telephone_next_call',
            'telephone_child_link',
            'personInCharge',
            'telephone_follow_up_status',
            'telephone_hold_count',
        ],
    },

    TELEPHONE_CALL_TYPE: {
        VOICE: 'telephone_call_type_voice',
        PHONE: 'telephone_call_type_phone',
        TRAINING: 'telephone_call_type_training',
        APP_INTEGRATION: 'telephone_call_type_app_integration',
    },

    TELEPHONE_CALL_MODE: {
        INBOUND: 'telephone_call_mode_inbound',
        OUTBOUND: 'telephone_call_mode_outbound',
        TRAINING: 'telephone_call_mode_training',
        APP_INTEGRATION: 'telephone_call_mode_app_integration',
    },

    TELEPHONE_CALL_STATUS: {
        CALL_WAITING: 'telephone_call_status_waiting',
        DURING_CALL: 'telephone_call_status_during',
        END_CALL: 'telephone_call_status_ended',
        MISSING_CALL: 'telephone_call_status_missed',
        CANCELLED_CALL: 'telephone_call_status_cancelled',
    },
    
    TELEPHONE_CALL_STATUS_LABEL: {
        CALL_WAITING: '通話待ち',
        DURING_CALL: '通話中',
        END_CALL: '通話終了',
        MISSING_CALL: '不在着信',
        CANCELLED_CALL: 'キャンセルした通話',
    },

    TELEPHONE_CALL_STATUS_COLOR: {
        CALL_WAITING: 'rgb(255, 255, 255)',
        DURING_CALL: 'rgb(255, 255, 255)',
        END_CALL: 'rgb(255, 255, 255)',
        MISSING_CALL: 'rgb(255, 255, 255)',
        CANCELLED_CALL: 'rgb(255, 255, 255)',
    },
    TELEPHONE_CALL_STATUS_BACKGROUND: {
        CALL_WAITING: 'rgb(245, 158, 11)',
        DURING_CALL: 'rgb(37, 99, 235)',
        END_CALL: 'rgb(127, 127, 127)',
        MISSING_CALL: 'rgb(229, 57, 53)',
        CANCELLED_CALL: 'rgb(156, 163, 175)',
    },

    TELEPHONE_FIELD_LABEL: {
        CALL_STATUS: '通話ステータス',
        TELEPHONE_RELATED_TICKETS: '前回の通話',
        TELEPHONE_NEXT_CALL: '次回の通話',
    },
    
    /**
     * AI_TELEPHONE_SYSFIELD_TO_PROPERTY_MAP
     * Mapping table from sysfield to Elasticsearch property name for AI Telephone fields
     * Used to ensure correct mapping regardless of field order
     */
    AI_TELEPHONE_SYSFIELD_TO_PROPERTY_MAP: {
        // Direct matches (sysfield = property name)
        'outline': 'outline',
        'ai_telephone_operator_name': 'ai_telephone_operator_name',
        'field_chatgpt_model_ai_auto': 'field_chatgpt_model_ai_auto',
        'field_reasoning_effort_ai_auto': 'field_reasoning_effort_ai_auto',
        'description': 'description',
        'sdauto_script_flow': 'sdauto_script_flow',
        'ai_telephone_trigger_condition': 'ai_telephone_trigger_condition',
        'ai_telephone_receiving_call_execution_mode': 'ai_telephone_receiving_call_execution_mode',
        'ai_telephone_time_based_delay_response': 'ai_telephone_time_based_delay_response',
        'ai_telephone_receiving_call_execution_time_period': 'ai_telephone_receiving_call_execution_time_period',
        'ai_telephone_receiving_call_execution_start_time': 'ai_telephone_receiving_call_execution_start_time',
        'ai_telephone_receiving_call_execution_end_time': 'ai_telephone_receiving_call_execution_end_time',
        'ai_telephone_receiving_call_execution_start_date': 'ai_telephone_receiving_call_execution_start_date',
        'ai_telephone_receiving_call_execution_end_date': 'ai_telephone_receiving_call_execution_end_date',
        'ai_telephone_receiving_call_execution_day_of_weeks': 'ai_telephone_receiving_call_execution_day_of_weeks',
        'ai_telephone_applicable_phone_number': 'ai_telephone_applicable_phone_number',
        'ai_telephone_execution_scope': 'ai_telephone_execution_scope',
        'ai_telephone_voice_settings': 'ai_telephone_voice_settings',
        // Special mappings (sysfield != property name)
        'AIPromptBody': 'ai_prompt_body',
        'ApplyAIprompt': 'apply_ai_prompt',
        'ai_telephone_realtime_model':'ai_telephone_realtime_model'
    },

    /**
     * SYSTEM_FIELD_LABEL
     * Label constants for telephone system fields
     */
    SYSTEM_FIELD_LABEL: {
        // AI Telephone Prompt fields
        AI_TELEPHONE_OPERATOR_NAME: 'AIオペレータ名',
        AI_TELEPHONE_GREETING: 'AIからの開始メッセージ',
        AI_TELEPHONE_REALTIME_MODEL: 'AIオペレータのモデル',
        AI_TELEPHONE_TRIGGER_CONDITION: 'AI-プロンプト実行条件',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_MODE: 'AI-対応モード',
        AI_TELEPHONE_TIME_BASED_DELAY_RESPONSE: 'AI対応開始までの待機時間 (秒)',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_TIME_PERIOD: '専用時間帯設定',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_START_TIME: 'AI-実行開始時刻',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_END_TIME: 'AI-実行終了時刻',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_START_DATE: 'AI-実行開始日',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_END_DATE: 'AI-実行終了日',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_DAY_OF_WEEKS: '曜日',
        AI_TELEPHONE_APPLICABLE_PHONE_NUMBER: '適用対象の電話番号',
        AI_TELEPHONE_VOICE_SETTINGS: 'AI-音声設定',
        AI_TELEPHONE_EXECUTION_SCOPE: 'AI-プロンプト適用範囲',
        
        // AI Telephone Realtime Model items
        AI_TELEPHONE_REALTIME_MODEL_GPT_REALTIME: 'gpt-realtime',
        AI_TELEPHONE_REALTIME_MODEL_GPT_REALTIME_MINI: 'gpt-realtime-mini',
        AI_TELEPHONE_REALTIME_MODEL_GPT_4O_REALTIME_PREVIEW: 'gpt-4o-realtime-preview',
        AI_TELEPHONE_REALTIME_MODEL_GPT_4O_REALTIME_MINI_PREVIEW: 'gpt-4o-mini-realtime-preview',
        AI_TELEPHONE_REALTIME_MODEL_GPT_REALTIME_1_5: 'gpt-realtime-1.5',
        AI_TELEPHONE_REALTIME_MODEL_GPT_REALTIME_2: 'gpt-realtime-2',
        AI_TELEPHONE_REALTIME_MODEL_GPT_REALTIME_2_1: 'gpt-realtime-2.1',
        AI_TELEPHONE_REALTIME_MODEL_GPT_REALTIME_2_1_MINI: 'gpt-realtime-2.1-mini',
        
        // AI Telephone Trigger Condition items
        AI_TELEPHONE_TRIGGER_CONDITION_RECEIVING: '受信時',
        AI_TELEPHONE_TRIGGER_CONDITION_MAKING: '発信時',
        AI_TELEPHONE_TRIGGER_CONDITION_TRAINING: 'トレーニング時',
        AI_TELEPHONE_TRIGGER_CONDITION_APP_INTEGRATION: 'アプリ連携時',
        
        // AI Telephone Receiving Call Execution Mode items
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_MODE_IMMEDIATE: '即時応答モード',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_MODE_ANSWERING_MACHINE: '留守番電話モード',
        
        // AI Telephone Receiving Call Execution Time Period items
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_TIME_PERIOD_ITEM: '専用時間帯設定',
        
        // AI Telephone Receiving Call Execution Day Of Weeks items
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_DAY_OF_WEEKS_MONDAY: '月曜日',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_DAY_OF_WEEKS_TUESDAY: '火曜日',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_DAY_OF_WEEKS_WEDNESDAY: '水曜日',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_DAY_OF_WEEKS_THURSDAY: '木曜日',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_DAY_OF_WEEKS_FRIDAY: '金曜日',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_DAY_OF_WEEKS_SATURDAY: '土曜日',
        AI_TELEPHONE_RECEIVING_CALL_EXECUTION_DAY_OF_WEEKS_SUNDAY: '日曜日',
        
        // AI Telephone Execution Scope items
        AI_TELEPHONE_EXECUTION_SCOPE_INTERNAL: '内線',
        AI_TELEPHONE_EXECUTION_SCOPE_EXTERNAL: '外線',
        
        // AI Telephone Voice Settings items
        AI_TELEPHONE_VOICE_SETTINGS_ALLOY: 'alloy (力強くメタリックな声)',
        AI_TELEPHONE_VOICE_SETTINGS_ASH: 'ash (落ち着いた柔らかい声)',
        AI_TELEPHONE_VOICE_SETTINGS_BALLAD: 'ballad (感情豊かで抒情的な声)',
        AI_TELEPHONE_VOICE_SETTINGS_CORAL: 'coral (温かく親しみやすい声)',
        AI_TELEPHONE_VOICE_SETTINGS_ECHO: 'echo (反響のある幻想的な声)',
        AI_TELEPHONE_VOICE_SETTINGS_SAGE: 'sage (知的で穏やかな声)',
        AI_TELEPHONE_VOICE_SETTINGS_SHIMMER: 'shimmer (輝く軽やかな声)',
        AI_TELEPHONE_VOICE_SETTINGS_VERSE: 'verse (詩的でリズミカルな声)',
        AI_TELEPHONE_VOICE_SETTINGS_MARIN: 'marin (爽やかで透き通った海のような声)',
        AI_TELEPHONE_VOICE_SETTINGS_CEDAR: 'cedar (温かく木質で落ち着いた声)',
        
        // Telephone system fields
        TELEPHONE_CALL_STATUS: '通話ステータス',
        TELEPHONE_CALL_TYPE: '通話種類',
        TELEPHONE_CALL_MODE: '通話モード',
        TELEPHONE_FROM: '発信者',
        TELEPHONE_TO: '受信者',
        TELEPHONE_CALL_HANDLER: '応対者',
        TELEPHONE_CALLER_LANGUAGE: '言語種（発信側）',
        TELEPHONE_RECEIVER_LANGUAGE: '言語種（受信側）',
        TELEPHONE_START_TIME: '通話開始時刻',
        TELEPHONE_END_TIME: '通話終了時刻',
        TELEPHONE_DURATION: '通話の総時間',
        TELEPHONE_CALL_RECORDING_URL: '通話音声へのURL',
        TELEPHONE_TRANSCRIPT_URL: '文字起こし記録へのURL',
        TELEPHONE_AI_CALL_SUMMARY: 'AI-通話概要',
        TELEPHONE_HUMAN_MEMO: '通話メモ',
        TELEPHONE_AI_SCORE: 'AIによるスコア',
        TELEPHONE_AI_EVALUATION: 'AIによるフィードバック',
        TELEPHONE_EVALUATOR: '評価担当',
        TELEPHONE_HUMAN_SCORE: '評価担当によるスコア',
        TELEPHONE_HUMAN_EVALUATION: '評価担当によるフィードバック',
        TELEPHONE_AI_OPERATOR_PROMPT: 'AIオペレータプロンプトナレッジ',
        TELEPHONE_RELATED_TICKETS: '前回の通話',
        TELEPHONE_CHILD_LINK: 'エスカレーション先',
        TELEPHONE_HOLD_COUNT: '保留回数',
        
        // New fields labels
        TICKET_STATUS: 'ステータス',
        REVIEW_STATUS: '評価ステータス',
        FOLLOW_UP_STATUS: 'フォローアップ状況',
        NEXT_CALL: '次回の通話',
        
        // Review Status items
        REVIEW_STATUS_NOT_REQUIRED: '評価不要',
        REVIEW_STATUS_REQUIRED: '要評価',
        REVIEW_STATUS_DONE: '評価完了',
        
        // Follow-up Status items
        FOLLOW_UP_STATUS_NOT_REQUIRED: '対応不要',
        FOLLOW_UP_STATUS_REQUIRED: '要対応',
        FOLLOW_UP_STATUS_DONE: '対応完了',
        
        // Telephone Call Status items
        TELEPHONE_CALL_STATUS_WAITING: '通話待ち',
        TELEPHONE_CALL_STATUS_DURING: '通話中',
        TELEPHONE_CALL_STATUS_ENDED: '通話終了',
        TELEPHONE_CALL_STATUS_MISSED: '不在着信',
        TELEPHONE_CALL_STATUS_CANCELLED: 'キャンセルした通話',
        
        // Telephone Call Type items
        TELEPHONE_CALL_TYPE_VOICE: '内線電話',
        TELEPHONE_CALL_TYPE_PHONE: '外線電話',
        TELEPHONE_CALL_TYPE_TRAINING: 'トレーニング通話',
        TELEPHONE_CALL_TYPE_APP_INTEGRATION: 'アプリ連携通話',
        
        // Telephone Call Mode items
        TELEPHONE_CALL_MODE_INBOUND: '着信',
        TELEPHONE_CALL_MODE_OUTBOUND: '発信',
        TELEPHONE_CALL_MODE_TRAINING: 'トレーニング',
        TELEPHONE_CALL_MODE_APP_INTEGRATION: 'アプリ連携',
        
        // Telephone Caller Language items
        TELEPHONE_CALLER_LANGUAGE_JP: '日本語',
        TELEPHONE_CALLER_LANGUAGE_EN: '英語',
        TELEPHONE_CALLER_LANGUAGE_ZH_SIMPLIFIED: '中国語（簡体字）',
        TELEPHONE_CALLER_LANGUAGE_ZH_TRADITIONAL: '中国語（繁体字）',
        TELEPHONE_CALLER_LANGUAGE_KO: '韓国語',
        TELEPHONE_CALLER_LANGUAGE_FR: 'フランス語',
        TELEPHONE_CALLER_LANGUAGE_ES: 'スペイン語',
        TELEPHONE_CALLER_LANGUAGE_DE: 'ドイツ語',
        TELEPHONE_CALLER_LANGUAGE_IT: 'イタリア語',
        TELEPHONE_CALLER_LANGUAGE_PT: 'ポルトガル語',
        TELEPHONE_CALLER_LANGUAGE_VI: 'ベトナム語',
        TELEPHONE_CALLER_LANGUAGE_TH: 'タイ語',
        
        // Telephone Receiver Language items
        TELEPHONE_RECEIVER_LANGUAGE_JP: '日本語',
        TELEPHONE_RECEIVER_LANGUAGE_EN: '英語',
        TELEPHONE_RECEIVER_LANGUAGE_ZH_SIMPLIFIED: '中国語（簡体字）',
        TELEPHONE_RECEIVER_LANGUAGE_ZH_TRADITIONAL: '中国語（繁体字）',
        TELEPHONE_RECEIVER_LANGUAGE_KO: '韓国語',
        TELEPHONE_RECEIVER_LANGUAGE_FR: 'フランス語',
        TELEPHONE_RECEIVER_LANGUAGE_ES: 'スペイン語',
        TELEPHONE_RECEIVER_LANGUAGE_DE: 'ドイツ語',
        TELEPHONE_RECEIVER_LANGUAGE_IT: 'イタリア語',
        TELEPHONE_RECEIVER_LANGUAGE_PT: 'ポルトガル語',
        TELEPHONE_RECEIVER_LANGUAGE_VI: 'ベトナム語',
        TELEPHONE_RECEIVER_LANGUAGE_TH: 'タイ語',
    },

    /**
     * TIME_PERIOD_24_7_VALUE
     * Constant value to indicate 24/7 support (no time restrictions)
     * When time_period = "ALL", ticket is always valid regardless of date/time/day_of_week
     */
    TIME_PERIOD_24_7_VALUE: 'ALL',

    WEBRTC_CONNECTION_STATE: {
        DISCONNECTED: 'disconnected',
        FAILED: 'failed',
        CLOSED: 'closed',
        CONNECTED: 'connected',
        CONNECTING: 'connecting',
        NEW: 'new',
    },

    WEBRTC_TERMINAL_STATES: ['disconnected', 'failed', 'closed'],

    HOLDER_SIDE: {
        CALLER: 'CALLER',
        CALLEE: 'CALLEE',
        AGENT: 'AGENT',
    },

    // Defines the call relationship (who calls whom) based on source → target entities
    VOICE_CALL_FLOW: {
        PROJECT_TO_PROJECT: 'PROJECT_TO_PROJECT',
        PROJECT_TO_USER: 'PROJECT_TO_USER',
        USER_TO_PROJECT: 'USER_TO_PROJECT',
        UNKNOWN: 'UNKNOWN',
    },

    UNSUPPORTED_REALTIME_MODELS: [
        'gpt-4o-realtime-preview',
        'gpt-4o-mini-realtime-preview'
    ],

    HOLD_STATE: {
        ACTIVE_DIAL: 'ACTIVE_DIAL',
        JOINING_CONF: 'JOINING_CONF',
        ACTIVE_CONF: 'ACTIVE_CONF',
        HELD: 'HELD',
        FAILED: 'FAILED',
        ENDED: 'ENDED',
    },

    CUSTOMER: {
        KEY: 'customer',
        LABEL: 'カスタマー'
    },

    MSG_VOICE_ROLE: {
        AGENT: 'agent',
        CUSTOMER: 'customer'
    },

    // Tools call timeout of the AI operator during a voice call (CR-2026-005 §5)
    TELEPHONE_TOOLS_CALL_CONFIG: {
        TIMEOUT_MIN_SECONDS: 5,
        TIMEOUT_MAX_SECONDS: 180,
        TIMEOUT_DEFAULT_SECONDS: 60
    },

    // Payload of the `function_call_output` handed back to the Realtime API when a
    // tools call does not produce a normal result. Kept in sync with the backend
    // TelephoneConstant.TELEPHONE_TOOLS_CALL_OUTPUT so the AI receives the same
    // instruction in the training flow and the production flow (CR-2026-005 BR-6).
    TELEPHONE_TOOLS_CALL_OUTPUT: {
        STATUS: {
            SUCCESS: 'success',
            FAILURE: 'failure',
            ERROR: 'error',
            CANCELLED: 'cancelled'
        },
        REASON: {
            TIMEOUT: 'timeout',
            ON_HOLD: 'on_hold',
            CALL_ENDED: 'call_ended',
            SYSTEM_ERROR: 'system_error'
        },
        MESSAGE: {
            SYSTEM_ERROR: 'The lookup failed. Tell the customer you could not retrieve the information.',
            TIMEOUT: 'The lookup was cancelled because it took too long. Do not retry it. '
                + 'Tell the customer you could not confirm the information and follow the guidance in your instructions.',
            CANCELLED: 'The lookup was cancelled. Decide whether to retry it or answer without it.'
        }
    },

    // Hold behaviour of the WebRTC training client while an AI tools call runs
    // (CR-2026-005 BR-4). Mirrors the timing sdesk-websocket uses for Twilio.
    TELEPHONE_TOOLS_CALL_HOLD: {
        // Delay before the hold music starts, so it does not talk over the short
        // announcement the AI produces right before the lookup.
        MUSIC_START_DELAY_MS: 2000
    },
};

export default TelephoneConstant;
